import api from '@/soluqr/api/client';
import { normalizeCustomerPhone } from '@/lib/phone';
import { withCustomerSession } from '@/lib/customerSession';

/**
 * @param {{ businessId: string, phone: string }} params
 */
export async function getCheckoutLoyaltySummary({ businessId, phone }) {
  const bid = String(businessId || '').trim();
  const ph = normalizeCustomerPhone(phone);
  const { data } = await api.get(
    '/customers/loyalty/checkout-summary',
    withCustomerSession(
      {
        params: { business_id: bid, phone: ph || phone },
      },
      bid,
    ),
  );
  return data;
}

export function formatCheckoutLoyaltyPoints(value) {
  const v = Number(value);
  if (!Number.isFinite(v)) return '0';
  return Math.round(v).toLocaleString('es-CL');
}

/**
 * @param {{ can_redeem?: boolean, points_missing?: number, points_cost?: number }} reward
 */
export function formatCheckoutRewardAvailability(reward) {
  if (reward?.can_redeem) {
    return { label: 'Disponible', variant: 'default' };
  }
  const missing = Number(reward?.points_missing);
  if (Number.isFinite(missing) && missing > 0) {
    return {
      label: `Te faltan ${formatCheckoutLoyaltyPoints(missing)} pts`,
      variant: 'secondary',
    };
  }
  const cost = Number(reward?.points_cost);
  if (Number.isFinite(cost) && cost > 0) {
    return {
      label: `Requiere ${formatCheckoutLoyaltyPoints(cost)} pts`,
      variant: 'secondary',
    };
  }
  return { label: 'Consultar en local', variant: 'outline' };
}

export function shouldFetchCheckoutLoyalty(phone) {
  return normalizeCustomerPhone(phone).length >= 8;
}
